import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 25
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function TestimonialsSection() {
  return <section className="w-full bg-brand-card py-20 md:py-28 px-6" data-id="element-542">
      <div className="max-w-5xl mx-auto" data-id="element-543">
        <motion.div className="relative text-center mb-14" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-544">
          <div className="absolute left-1/2 -translate-x-1/2 top-[-20%] w-[800px] h-[600px] bg-[#22c55e]/[0.14] rounded-full blur-[120px] pointer-events-none" data-id="element-545" />
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-extrabold text-gray-900 leading-tight relative z-10" data-id="element-546">
            Resultados reales de
            <br data-id="element-547" />
            <span className="text-[#1fa855]" data-id="element-548">personas como vos</span>
          </h2>
          <p className="text-lg md:text-2xl text-gray-600 mt-4 relative z-10" data-id="element-549">
            Esto dicen quienes ya están aplicando el curso 👇
          </p>
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-3 gap-6" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} data-id="element-550">
          <motion.div variants={itemVariants} className="bg-white rounded-xl border border-gray-200 shadow-sm p-8" data-id="element-551">
            <p className="text-brand-dark/70 leading-relaxed mb-6" data-id="element-552">
              "Por fin alguien que te explica las cosas de forma simple. Dejé de
              dar vueltas y empecé a{' '}
              <span className="text-brand-green font-semibold" data-id="element-553">avanzar</span> de
              verdad."
            </p>
            <div className="flex items-center gap-3" data-id="element-554">
              <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center text-brand-green font-semibold text-sm" aria-hidden="true" data-id="element-555">
                M
              </div>
              <span className="text-sm font-medium text-brand-dark" data-id="element-556">
                Martina
              </span>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white rounded-xl border border-gray-200 shadow-sm p-8" data-id="element-557">
            <p className="text-brand-dark/70 leading-relaxed mb-6" data-id="element-558">
              "Había probado de todo y nada me funcionaba. Este curso me dio la{' '}
              <span className="text-brand-green font-semibold" data-id="element-559">claridad</span>{' '}
              que necesitaba para elegir un camino y seguirlo."
            </p>
            <div className="flex items-center gap-3" data-id="element-560">
              <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center text-brand-green font-semibold text-sm" aria-hidden="true" data-id="element-561">
                L
              </div>
              <span className="text-sm font-medium text-brand-dark" data-id="element-562">Lucas</span>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white rounded-xl border border-gray-200 shadow-sm p-8" data-id="element-563">
            <p className="text-brand-dark/70 leading-relaxed mb-6" data-id="element-564">
              &quot;Lo mejor es que va directo al punto. Sin relleno, sin
              promesas exageradas. Justo{' '}
              <span className="text-brand-green font-semibold" data-id="element-565">
                lo que necesitaba
              </span>{' '}
              para empezar."
            </p>
            <div className="flex items-center gap-3" data-id="element-566">
              <div className="w-10 h-10 rounded-full bg-brand-green/15 flex items-center justify-center text-brand-green font-semibold text-sm" aria-hidden="true" data-id="element-567">
                S
              </div>
              <span className="text-sm font-medium text-brand-dark" data-id="element-568">Sofía</span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}